import React from 'react';
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from "@tanstack/react-query";
import App from './App.tsx'
import './index.css'
import { initSentry, captureException } from './lib/sentry';
import { initPostHog } from './lib/posthog';

// Initialize Sentry for error tracking
initSentry();

// Initialize PostHog for product analytics
initPostHog();

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      captureException(error instanceof Error ? error : new Error(String(error)), { source: 'react-query' });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      captureException(error instanceof Error ? error : new Error(String(error)), { source: 'react-query-mutation' });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Ensure we have a valid DOM element before rendering
const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );
} else {
  console.error("Root element not found");
}
